// Actions
export const SFX_FETCH  = '[Sfx] Fetch'

// Mutations
export const SFX_META   = '[Sfx] meta'
export const SFX_SAMPLE   = '[Sfx] sfx_sample'
export const SFX_OBTAIN = '[Sfx] obtain'
export const SFX_CLEAR  = '[Sfx] clear'
export const SFX_SET_LOADING = '[Sfx] set loading'
